function showFlLoader() {
	$('#fl_loader_v01').removeClass('tw-hidden');
}

function hideFlLoader() {
	$('#fl_loader_v01').addClass('tw-hidden');
}

// Expose to window for inline scripts
window.showFlLoader = showFlLoader;
window.hideFlLoader = hideFlLoader;